/*
  Get Items From List - getItemsFromList

  Generic function to get a clean array of items from lists created in the CMS.

  Since the CMS doesn't allow to create repeatable fields to create lists, you have to create 2 Content Types:
  1. A list Content Type. Ex: Fruits list
  2. An item Content type. Ex: Fruit item. This type has an text field called 'Name' (codename = name).

  From there, to get to the first element of the list, you have to access: fruits?.value?.elements.fruit.value[0].elements.name.value
  This is a nightmare that this function helps smooth a little.
*/

export type listItem = {
  readonly elements: {
    readonly name: {
      readonly value: string;
    };
  };
};

export const getItemsFromList = (list?: listItem[]) =>
  list?.reduce((allItems: string[], item) => {
    allItems.push(item.elements.name.value);
    return allItems;
  }, []);
